import Campaign from '../store/Campaign';
import { campaignStore } from '../store/store';
import { setCampaignVisibility } from '../mutators/setCampaignVisibility';

/**
 * Function to start the campaign and set the campaign view state to true
 * @param campaign Campaign object
 */
export const startCampaign = <T extends {}>(campaign: Campaign<T>) => {
    const campaignId = campaign.getRemoteCampaignId();
    const visibilityMap = campaignStore.campaignVisibleMap;
    if (campaignId && !visibilityMap.has(campaign)) {
        /**
         * Send a call to remote source only once during the session,
         * when we are starting campaign for the first time.
         */
        campaign.getRemoteSource().start(campaignId);
    }
    setCampaignVisibility(campaign, true);
};
